<ng-container *ngIf="isCustom && isDocumentAvailable">
  <a href="" role="button" (click)="openDocument($event, params)">
    <eds-icon
      [type]="regulatoryDocumentFileExtension"
      [addTitle]="regulatoryDocumentFileExtension"
      size="large"
      [attr.aria-label]="
        ('literature.download' | translate) +
        ' ' +
        params?.data?.literatureData?.fundNameGenerated
      "
    ></eds-icon>
  </a>
</ng-container>
<p *ngIf="isCustom && !isDocumentAvailable">
  {{ "literature.NA" | translate }}
</p>
<ng-container *ngIf="thumbnailAvailable && !isCustom">
  <div
    [class.icon-column__image-wrapper]="!isSiteIntl"
    class="icon-column--{{ imageLayout }}"
    edsFlexbox
    justifyContent="center"
  >
    <ng-container
      *ngIf="!isSiteIntl && (loginRequired || !isShowDownload)"
      [ngTemplateOutlet]="image"
      [ngTemplateOutletContext]="{
        className:
          imageLayout === 'portrait' ? ' img--full-height img--expand' : ''
      }"
    >
    </ng-container>
    <a
      *ngIf="!isSiteIntl && !loginRequired && isShowDownload"
      role="button"
      [attr.aria-label]="
        ('literature.download' | translate) +
        ' ' +
        params?.data?.literatureData?.fundNameGenerated
      "
      class="text-align-center"
      (click)="openImageDoc(params?.data)"
    >
      <ng-container
        [ngTemplateOutlet]="image"
        [ngTemplateOutletContext]="{
          className:
            imageLayout === 'portrait' ? ' img--full-height img--expand' : ''
        }"
      >
      </ng-container>
    </a>
    <ng-container *ngIf="isSiteIntl" [ngTemplateOutlet]="image"> </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="!thumbnailAvailable && !isCustom && isSiteIntl">
  <eds-icon
    [type]="params?.data?.literatureData?.fileExtension"
    size="normal"
    [addTitle]="params?.data?.literatureData?.fileExtension"
  ></eds-icon>
</ng-container>
<ng-container *ngIf="!thumbnailAvailable && !isCustom && !isSiteIntl">
  <div class="text-align-center icon-wrapper">
    <a
      [attr.aria-label]="
        ('literature.download' | translate) +
        ' ' +
        params?.data?.literatureData?.fundNameGenerated
      "
      role="button"
      (click)="openImageDoc(params?.data)"
    >
      <eds-icon
        [type]="params?.data?.literatureData?.fileExtension"
        size="normal"
        [addTitle]="params?.data?.literatureData?.fileExtension"
      ></eds-icon
    ></a>
  </div>
</ng-container>
<ng-template #image let-className="className">
  <eds-image
    [className]="'img--grey-border img--full-width' + className"
    *ngIf="!showOnlyIcon"
    [imgSrc]="params?.data?.literatureData?.imageUrl"
    [altText]=""
    class="spacingWrapper"
    (imageLoad)="onImageLoad($event)"
  >
  </eds-image>
  <eds-icon
    *ngIf="showOnlyIcon"
    [type]="params?.data?.literatureData?.fileExtension"
    [addTitle]="params?.data?.literatureData?.fileExtension"
    size="normal"
  ></eds-icon>
</ng-template>
